<template>
  <div
    class="text-lg pl-12"
    :class="[overBudget.isOver ? 'text-theme-6' : 'text-theme-9']"
    v-show="overBudget.show"
  >
    ( {{ overBudget.message }} )
  </div>
</template>

<script>
import { defineComponent, computed } from 'vue'
import { useStore } from '@/store'

export default defineComponent({
  setup() {
    const store = useStore()
    const overBudget = computed(() => store.state.global.overBudget)
    return {
      overBudget
    }
  }
})
</script>

<style scoped></style>
